"use client";

import { type FormEvent, type FormEventHandler, type ReactNode } from "react";
import { useConfirm } from "./confirm-gate";

interface ConfirmGatedFormProps {
	action: (formData: FormData) => void | Promise<void>;
	id?: string;
	className?: string;
	onReset?: FormEventHandler<HTMLFormElement>;
	children: ReactNode;
}

export function ConfirmGatedForm({ action, id, className, children, onReset }: ConfirmGatedFormProps) {
	const { isConfirmed, requestConfirm } = useConfirm();

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		if (isConfirmed) return;
		event.preventDefault();
		const form = event.currentTarget;
		const submitter = (event.nativeEvent as SubmitEvent).submitter;
		requestConfirm(() => {
			form.requestSubmit(submitter);
		});
	};

	return (
		<form action={action} id={id} className={className} onSubmit={handleSubmit} onReset={onReset}>
			{children}
		</form>
	);
}
